import { render, staticRenderFns } from "./offerhome.vue?vue&type=template&id=2edeadf9&scoped=true&"
import script from "./offerhome.vue?vue&type=script&lang=js&"
export * from "./offerhome.vue?vue&type=script&lang=js&"
import style0 from "./offerhome.vue?vue&type=style&index=0&id=2edeadf9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edeadf9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VDatePicker,VIcon,VMenu})
